import { ComponentChildren } from "preact"
import { SettingsLayout } from "../layout"
import { DangerZone } from "./danger-zone"

interface IntegrationSettingsLayoutProps {
  logo?: string
  name: string
  username: string
  integrationId: string
  children: ComponentChildren
}

export function IntegrationSettingsLayout({
  logo,
  name,
  username,
  integrationId,
  children,
}: IntegrationSettingsLayoutProps) {
  let header
  if (logo) {
    header = (
      <div class="flex items-center gap-5">
        <img src={logo} alt={name} class="h-20 w-28 object-contain" />
        <p class="text-sm text-gray-500">{username}</p>
      </div>
    )
  } else {
    header = (
      <div class="flex items-center gap-5">
        <div class="h-20 w-20 bg-gray-100 rounded-lg flex items-center justify-center text-3xl font-bold text-gray-600">
          {name.charAt(0).toUpperCase()}
        </div>
        <div>
          <h1 class="text-2xl font-semibold text-gray-900">{name}</h1>
          <p class="text-sm text-gray-500">{username}</p>
        </div>
      </div>
    )
  }
  return (
    <SettingsLayout>
      {header}
      {children}
      <DangerZone integrationId={integrationId} integrationName={name} />
    </SettingsLayout>
  )
}

interface SettingsSectionProps {
  title: string
  children: ComponentChildren
}

export function SettingsSection({ title, children }: SettingsSectionProps) {
  return (
    <div class="bg-white border border-gray-200 rounded-lg p-4 text-gray-700">
      <h2 class="text-sm font-medium text-gray-900 mb-2">{title}</h2>
      {children}
    </div>
  )
}
